import { render, staticRenderFns } from "./CN.vue?vue&type=template&id=5465b2d3&scoped=true&"
import script from "./CN.vue?vue&type=script&lang=js&"
export * from "./CN.vue?vue&type=script&lang=js&"
import style0 from "./CN.vue?vue&type=style&index=0&id=5465b2d3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5465b2d3",
  null
  
)

export default component.exports